








import Vue from "vue";
import IconButton from "./IconButton.vue"

export default Vue.extend({
  name: "ToolButton",
  components: {
    IconButton
  },
  props: {
    tool: String,
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    selected(): boolean {
      return this.$store.state.activeTool === this.tool
    }
  }
});
